import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=381498c5&"
import script from "./Rank.vue?vue&type=script&lang=ts&"
export * from "./Rank.vue?vue&type=script&lang=ts&"
import style0 from "./Rank.vue?vue&type=style&index=0&id=381498c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports